<template>
	<orders-kanban-index />
</template>